/**
 * 百炼平台对比评价配置
 *
 * 说明：
 * 1. 前端无法真正保存密钥，这里仅做「字符异或 + 分片 + 乱序」处理，避免源码中出现完整明文；
 *    这只能提高从源码中直接抓取的门槛，无法替代服务端密钥管理，生产环境仍建议改为服务端代理，
 *    并配合百炼平台的限流、告警能力。
 * 2. 替换 agentId：直接修改 BAILIAN_COMPARE_AGENT_ID。
 * 3. 替换 apiKey：
 *    - 执行 node scripts/encode-bailian-key.mjs '新的 apiKey'
 *    - 复制脚本输出，替换下方「API_KEY_PARTS 开始」到「API_KEY_PARTS 结束」之间的内容
 *    - 重新构建/发布（key 在前端产物中，必须重新构建）
 * 4. 注意：不要在日志、注释或控制台中输出真实 apiKey。
 */

/** 百炼对比评价应用 ID */
export const BAILIAN_COMPARE_AGENT_ID = '14220a78a2cc42399c77dcaee9eecb67';

// ===== API_KEY_PARTS 开始 =====
const API_KEY_PARTS = [
  [
    57, 110, 111, 107, 104, 108, 98, 59, 107, 62, 60,
  ],
  [
    41, 49, 119, 57, 59, 105, 63, 104, 59, 60, 104, 105,
  ],
  [
    62, 56, 63, 110, 111, 62, 57, 98, 59, 108, 109, 60,
  ],
];

const API_KEY_ORDER = [1, 2, 0];
// ===== API_KEY_PARTS 结束 =====

/** 与 scripts/encode-bailian-key.mjs 保持一致的异或值 */
const API_KEY_XOR = 0x5A;

/**
 * @description 还原百炼 API Key
 * 按 API_KEY_ORDER 还原分片顺序，再逐字符异或还原
 */
export function getBailianApiKey() {
  const codes = API_KEY_ORDER.reduce<number[]>((all, index) => all.concat(API_KEY_PARTS[index]), []);
  return codes.map((code) => String.fromCharCode(code ^ API_KEY_XOR)).join('');
}
